module.exports = require('./lib/visibility.timers.js')



//////////////////
// WEBPACK FOOTER
// ./~/visibilityjs/index.js
// module id = 809
// module chunks = 12 16 17